import { FC } from "react";
import {
  Checkbox,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Flex,
} from "@chakra-ui/react";

export const CustomCheckbox: FC<any> = ({
  name,
  label,
  meta,
  input: { checked, ...input },
  ...props
}) => {
  console.log('input?', input)
  if (props.inline) {
    return (
      <FormControl isInvalid={meta.error && meta.touched} padding={'20px 0'}>
        <Flex alignItems={"center"}>
          <Flex
            h="100%"
            justifyContent={"center"}
            alignItems={"center"}
            marginRight={"10px"}
          >
            <Checkbox
              {...props}
              {...input}
              isInvalid={meta.error && meta.touched}
              id={name}
              isChecked={!!input.value || checked}
              size="lg"
              colorScheme="orange"
            />
          </Flex>
          <Flex justifyContent={"center"} alignItems={"center"}>
            <FormLabel
              margin={0}
              color="#000"
              htmlFor={name}
              sx={{
                fontWeight: "700",
                fontSize: "13px",
                lineHeight: "12px",
                // color: "#A6A8AE",
                color: "#000",
              }}
            >
              {label}
            </FormLabel>
          </Flex>
        </Flex>
        <FormErrorMessage>{meta.error}</FormErrorMessage>
      </FormControl>
    );
  }
  return (
    <FormControl isInvalid={meta.error && meta.touched} h="50%">
      <Flex justifyContent={"center"} alignItems={"center"}>
        <FormLabel
          htmlFor={name}
          sx={{
            fontWeight: "700",
            fontSize: "10px",
            lineHeight: "12px",
            color: "#A6A8AE",
          }}
        >
          {label}
        </FormLabel>
      </Flex>
      <Flex h="100%" justifyContent={"center"} alignItems={"center"}>
        <Checkbox
          {...props}
          {...input}
          isInvalid={meta.error && meta.touched}
          id={name}
          isChecked={!!input.value || checked}
          size="lg"
          colorScheme="orange"
        />
      </Flex>
      <FormErrorMessage>{meta.error}</FormErrorMessage>
    </FormControl>
  );
};
